<template>
  <router-link
    v-for="employee in employees"
    :key="employee.id"
    :to="{ name: 'UserPage', params: { id: employee.id } }"
    class="flex justify-between items-center gap-4 p-2 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-sm"
  >
    <div class="flex items-center gap-2">
      <Image :src="getFlagUrl(employee.country)" :alt="employee.country" class="w-5 h-4" image-class="rounded-sm" />
      <span class="text-sm truncate">{{ employee.name }}</span>
    </div>
    <div class="flex flex-col gap-1">
      <span class="text-xs truncate">{{ employee.email }}</span>
      <span class="text-xs">{{ formatPhoneNumber(employee.phone) }}</span>
    </div>
    <span class="text-sm block">{{ employee.role.name }}</span>
  </router-link>
</template>

<script setup>
import { Image } from 'primevue'
import { formatPhoneNumber, getFlagUrl } from '@/utils/helpers'

defineProps({
  employees: { type: Array, default: () => [] },
})
</script>
